export enum MessageType {
  STATUS_UPDATE = "STATUS_UPDATE",
  SMS_FROM_STORE_STAFF = "SMS_FROM_STORE_STAFF",
  EMAIL_FROM_STORE_STAFF = "EMAIL_FROM_STORE_STAFF",
  AUTOMATIC_SMS_FROM_STORE = "AUTOMATIC_SMS_FROM_STORE",
  AUTOMATIC_EMAIL_FROM_STORE = "AUTOMATIC_EMAIL_FROM_STORE",
  SMS_ABOUT_SERVICE_PROPOSAL = "SMS_ABOUT_SERVICE_PROPOSAL",
  EMAIL_ABOUT_SERVICE_PROPOSAL = "EMAIL_ABOUT_SERVICE_PROPOSAL",
  SMS_ABOUT_ADDON_ORDER = "SMS_ABOUT_ADDON_ORDER",
  EMAIL_ABOUT_ADDON_ORDER = "EMAIL_ABOUT_ADDON_ORDER",
  SMS_ABOUT_REVIEW = "SMS_ABOUT_REVIEW",
  EMAIL_ABOUT_REVIEW = "EMAIL_ABOUT_REVIEW",
  INTERNAL_COMMENT = "INTERNAL_COMMENT",
  MESSAGE_FROM_CUSTOMER = "MESSAGE_FROM_CUSTOMER",
  SMS_SERVICE_PROPOSAL_REMINDER = "SMS_SERVICE_PROPOSAL_REMINDER",
  SMS_COMPLETED_BIKE_REMINDER = "SMS_COMPLETED_BIKE_REMINDER",
  CUSTOMER_ANSWERED_ADDON_ORDER = "CUSTOMER_ANSWERED_ADDON_ORDER",
  CUSTOMER_ANSWERED_SERVICE_PROPOSAL = "CUSTOMER_ANSWERED_SERVICE_PROPOSAL",
  MECHANIC_REVOKED_SERVICE_PROPOSAL = "MECHANIC_REVOKED_SERVICE_PROPOSAL",
  MECHANIC_REVOKED_ADDON_ORDER = "MECHANIC_REVOKED_ADDON_ORDER",
  AUTOMATIC_SMS_PICKUP_READY = "AUTOMATIC_SMS_PICKUP_READY",
  AUTOMATIC_SMS_PICKUP_REMINDER = "AUTOMATIC_SMS_PICKUP_REMINDER",
  AUTOMATIC_EMAIL_PICKUP_READY = "AUTOMATIC_EMAIL_PICKUP_READY",
  AUTOMATIC_EMAIL_PICKUP_REMINDER = "AUTOMATIC_EMAIL_PICKUP_REMINDER",
  AUTOMATIC_SMS_PROPOSAL_REMINDER = "AUTOMATIC_SMS_PROPOSAL_REMINDER",
  AUTOMATIC_EMAIL_PROPOSAL_REMINDER = "AUTOMATIC_EMAIL_PROPOSAL_REMINDER",
}
